__turbopack_context__.v({
  "close": "s3Xlxa_close",
  "container": "s3Xlxa_container",
  "header": "s3Xlxa_header",
  "loading": "s3Xlxa_loading",
  "shimmer": "s3Xlxa_shimmer",
  "text-bar-sweep": "s3Xlxa_text-bar-sweep",
  "title": "s3Xlxa_title",
});
